const answers = [
  // Q 1.1
  { id: "1", test_id: "1", answer: "Техникийн тодорхойлолтыг нь үндэслэнэ" }, //
  {
    id: "2",
    test_id: "1",
    answer: "Тухайн үеийн бодит жинг нь харгалзан тодорхойлно",
  }, //
  {
    id: "3",
    test_id: "1",
    answer:
      "Автомашины өөрийн жин дээр тээж яваа ачааны жинг оролцуулан тодорхойлно",
  }, // [cite: 21, 22]

  // Q 1.2
  { id: "4", test_id: "2", answer: "Автомашины өөрийн жинтэй тэнцүү байна" }, //
  { id: "5", test_id: "2", answer: "Автомашины даацын хэмжээтэй тэнцүү байна" }, //
  { id: "6", test_id: "2", answer: "Ачаагүй хоосон байна" }, //

  // Q 1.3
  { id: "7", test_id: "3", answer: "Нэмэгдэнэ" }, //
  { id: "8", test_id: "3", answer: "Багасна" }, //
  { id: "9", test_id: "3", answer: "Өөрчлөгдөхгүй" }, //

  // Q 1.4
  { id: "10", test_id: "4", answer: "Зөвхөн ачаа ачих үед" }, //
  { id: "11", test_id: "4", answer: "Зөвхөн зорчигч суулгах үед" }, //
  { id: "12", test_id: "4", answer: "Зөвхөн чиргүүл чирэх үед" }, //
  {
    id: "13",
    test_id: "4",
    answer: "Зөвхөн ачаа ачих буюу зорчигч суулгах үед",
  }, //
  { id: "14", test_id: "4", answer: "Дээрх бүх тохиолдолд" }, //

  // Q 1.5
  { id: "15", test_id: "5", answer: "Зөвхөн А" }, //
  { id: "16", test_id: "5", answer: "Зөвхөн Б" }, //
  { id: "17", test_id: "5", answer: "А.Б" }, //
  {
    id: "18",
    test_id: "5",
    answer: "Автомашины бүх жинд чиргүүлийн бүх жинг оролцуулж тооцохгүй",
  }, //

  // Q 1.6
  {
    id: "19",
    test_id: "6",
    answer: "Зөвхөн чиргүүл чирч яваа тохиолдолд тооцно",
  }, //
  {
    id: "20",
    test_id: "6",
    answer: "Зөвхөн механикжан тээврийн хэрэгсэл чирч яваа тохиолдолд тооцно",
  }, //
  {
    id: "21",
    test_id: "6",
    answer: "Зөвхөн хагас чиргүүлтэй автомашины хувьд тооцно",
  }, //
  { id: "22", test_id: "6", answer: "Дээрх бүх тохиолдолд тооцно" }, //
  { id: "23", test_id: "6", answer: "Тооцохгүй" }, //

  // Q 1.7
  { id: "24", test_id: "7", answer: "Мотоцикл" }, //
  { id: "25", test_id: "7", answer: "Трактор" }, //
  { id: "26", test_id: "7", answer: "Троллейбус" }, //
  { id: "27", test_id: "7", answer: "Дээрх бүгд хамаарагдана" }, //
  { id: "28", test_id: "7", answer: "Дээрх бүгд хамаарагдахгүй" }, //

  // Q 1.8
  { id: "29", test_id: "8", answer: "Зөвхөн чиглэлийн тээврийн хэрэгслийг" }, //
  {
    id: "30",
    test_id: "8",
    answer: "Хүн тээвэрлэхэд зориулсан бүх төрлийн тээврийн хэрэгслийг",
  }, // [cite: 64, 65]
  {
    id: "31",
    test_id: "8",
    answer:
      "Жолоочоос гадна 8-аас илүү хүний суудалтай, хүн тээвэрлэхэд зориулсан, троллейбусаас бусад автомашиныг",
  }, // [cite: 66, 67]

  // Q 1.9
  {
    id: "32",
    test_id: "9",
    answer:
      "Тээврийн хэрэгсэл дээр буюу түүний бүхээг дотор байгаа жолоочоос бусад хүн",
  }, // [cite: 70, 71]
  {
    id: "33",
    test_id: "9",
    answer:
      "Зөвхөн механикжсан тээврийн хэрэгсэл дээр буюу түүний бүхээг дотор байгаа жолоочоос бусад хүн",
  }, //
  {
    id: "34",
    test_id: "9",
    answer: "Зөвхөн чиглэлийн тээврийн хэрэгслээр үйлчлүүлэгч",
  }, //
  {
    id: "35",
    test_id: "9",
    answer:
      "Зөвхөн хүн тээвэрлэхэд зориулсан тээврийн хэрэгслээр зорчиж яваа хүн",
  }, //

  // Q 1.10
  {
    id: "36",
    test_id: "10",
    answer:
      "Чиглэлийн тээврийн хэрэгслээр найм болон түүнээс олон хүүхдийг тээвэрлэх",
  }, //
  {
    id: "37",
    test_id: "10",
    answer:
      "Чиглалийн бус автобусаар найм болон түүнээс олон хүүхдийг тусгайлан тээвэрлэх",
  }, //
  {
    id: "38",
    test_id: "10",
    answer:
      "Механикжсан тээврийн хэрэгслээр хоёр буюу түүнээс олон хүүхдийг тусгайлан тээвэрлэх",
  }, // [cite: 79, 80]
  {
    id: "39",
    test_id: "10",
    answer:
      "Хүн тээвэрлэхэд зориулсан тээврийн хэрэгслээр хоёр буюу түүнээс олон хүүхдийг тээвэрлэх",
  }, //
  { id: "40", test_id: "11", answer: "Зөвшөөрнө" }, //
  { id: "41", test_id: "11", answer: "Хориглоно" }, //
  {
    id: "42",
    test_id: "11",
    answer: "Чиргүүлийн бүх жин нь 750 кг-аас их бол хориглоно",
  }, //
  {
    id: "43",
    test_id: "11",
    answer: "Чиргүүлийн даац нь 5 тонноос бага бол зөвшөөрнө",
  }, //

  // Q 2.2
  { id: "44", test_id: "12", answer: "'С' ангиллын эрхтэй" }, //
  { id: "45", test_id: "12", answer: "'СЕ' ангиллын эрхтэй" }, //
  { id: "46", test_id: "12", answer: "Дээрх хоёуланг зөвшөөрнө" }, //

  // Q 2.3
  { id: "47", test_id: "13", answer: "'С' ангилал" }, //
  { id: "48", test_id: "13", answer: "'CE' ангилал" }, //
  { id: "49", test_id: "13", answer: "'М' ангилал" }, //
  {
    id: "50",
    test_id: "13",
    answer: "Механикжсан тээврийн хэрэгслийн ангилалд хамаарагдахгүй",
  }, //

  // Q 2.4
  { id: "51", test_id: "14", answer: "Зөвхөн 'С' ангилал" }, //
  { id: "52", test_id: "14", answer: "Зөвхөн 'С1' дэд ангилал" }, //
  { id: "53", test_id: "14", answer: "'С' ангилал болон 'С1' дэд ангилал" }, //

  // Q 2.5
  { id: "54", test_id: "15", answer: "Зөвшөөрнө" }, //
  { id: "55", test_id: "15", answer: "Хориглоно" }, //

  // Q 2.6
  { id: "56", test_id: "16", answer: "Зөвшөөрнө" }, //
  { id: "57", test_id: "16", answer: "Хориглоно" }, //
  {
    id: "58",
    test_id: "16",
    answer: "Бүх жин нь 7.5 тонноос илүүгүй бол зөвшөөрнө",
  }, //

  // Q 2.7
  { id: "59", test_id: "17", answer: "Зөвшөөрнө" }, //
  { id: "60", test_id: "17", answer: "Хориглоно" }, //

  // Q 2.8
  { id: "61", test_id: "18", answer: "Зөвшөөрнө" }, //
  {
    id: "62",
    test_id: "18",
    answer: "Автомашины бүх жин нь 7.5 тонноос илүүгүй бол зөвшөөрнө",
  }, //
  { id: "63", test_id: "18", answer: "Хориглоно" }, //

  // Q 2.9
  { id: "64", test_id: "19", answer: "Зөвшөөрнө" }, //
  { id: "65", test_id: "19", answer: "Хориглоно" }, //
  {
    id: "66",
    test_id: "19",
    answer:
      "'D' ангиллын тээврийн хэрэгслийг 3-аас дээш жил жолоодож дадлагажсан бол зөвшөөрнө",
  }, //

  // Q 2.10
  { id: "67", test_id: "20", answer: "18 нас" }, //
  { id: "68", test_id: "20", answer: "21 нас" }, //
  { id: "69", test_id: "20", answer: "24 нас" }, //

  // Q 3.1
  { id: "70", test_id: "21", answer: "Зөвхөн А" }, //
  { id: "71", test_id: "21", answer: "Зөвхөн В" }, //
  { id: "72", test_id: "21", answer: "Зөвхөн А. В" }, //
  { id: "73", test_id: "21", answer: "Зөвхөн Б, Г" }, //
  { id: "74", test_id: "21", answer: "А, Б, В, Г" }, //

  // Q 3.2
  { id: "75", test_id: "22", answer: "Зөвшөөрнө" }, //
  { id: "76", test_id: "22", answer: "Хориглоно" }, //
  {
    id: "77",
    test_id: "22",
    answer: "Ачааны автомашины бодит жин нь 8 тонноос бага бол зөвшөөрнө",
  }, //

  // Q 3.3
  { id: "78", test_id: "23", answer: "Угсраа автобус" }, //
  { id: "79", test_id: "23", answer: "Чиргүүлтэй трактор" }, //
  { id: "80", test_id: "23", answer: "Чиргүүлтэй ачааны автомашин" }, //
  {
    id: "81",
    test_id: "23",
    answer: "Механикжсан тээврийн хэрэгсэл чирч яваа автомашин",
  }, //

  // Q 3.4
  { id: "82", test_id: "24", answer: "Зөвхөн А" }, //
  { id: "83", test_id: "24", answer: "Зөвхөн Б" }, //
  { id: "84", test_id: "24", answer: "Хоёуланг хориглоно" }, //
  { id: "85", test_id: "24", answer: "Хоёуланг зөвшөөрнө" }, //
  { id: "86", test_id: "25", answer: "Даац нь 7 тонноос их " },
  { id: "87", test_id: "25", answer: "Бодит жин нь 7 тонноос их " },
  { id: "88", test_id: "25", answer: "Бүх жин нь 7 тонноос их " },
  {
    id: "89",
    test_id: "25",
    answer: "Зөвхөн ачааны жин нь 7 тонноос их ",
  },

  // Q 3.6
  { id: "90", test_id: "26", answer: "Зөвшөөрнө " },
  { id: "91", test_id: "26", answer: "Хориглоно " },

  // Q 3.7
  { id: "92", test_id: "27", answer: "Зөвшөөрнө " },
  { id: "93", test_id: "27", answer: "Хориглоно " },

  // Q 3.8
  { id: "94", test_id: "28", answer: "Зөвхөн А " },
  { id: "95", test_id: "28", answer: "Зөвхөн Б " },
  { id: "96", test_id: "28", answer: "Хоёуланд хориглоно " },
  { id: "97", test_id: "28", answer: "Хоёуланд зөвшөөрнө " },

  // Q 3.9
  { id: "98", test_id: "29", answer: "Бодит жин нь 5 тонноос их " },
  { id: "99", test_id: "29", answer: "Бүх жин нь 5 тонноос их " },
  {
    id: "100",
    test_id: "29",
    answer: "Аль нэг тэнхлэгт ногдож буй бодит жин нь 5 тонноос их ",
  },

  // Q 3.10
  { id: "101", test_id: "30", answer: "Зөвхөн А " },
  { id: "102", test_id: "30", answer: "Зөвхөн Б " },
  { id: "103", test_id: "30", answer: "Зөвхөн А, В " },
  { id: "104", test_id: "30", answer: "Зөвхөн Б, В " },
  { id: "105", test_id: "30", answer: "А,Б,В " },

  // Q 3.11
  { id: "106", test_id: "31", answer: "Зөвшөөрнө " },
  { id: "107", test_id: "31", answer: "Хориглоно " },

  // Q 3.12
  { id: "108", test_id: "32", answer: "Зөвшөөрнө " },
  { id: "109", test_id: "32", answer: "Хориглоно " },

  // Q 3.13
  { id: "110", test_id: "33", answer: "Зөвшөөрнө " },
  { id: "111", test_id: "33", answer: "Хориглоно " },

  // Q 3.14
  { id: "112", test_id: "34", answer: "Зөвшөөрнө " },
  { id: "113", test_id: "34", answer: "Хориглоно " },

  // Q 3.15
  { id: "114", test_id: "35", answer: "Зөвшөөрнө " },
  { id: "115", test_id: "35", answer: "Хориглоно " },

  // Q 3.16
  { id: "116", test_id: "36", answer: "Зөвшөөрнө " },
  { id: "117", test_id: "36", answer: "Хориглоно " },

  // Q 3.17
  { id: "118", test_id: "37", answer: "Зөвшөөрнө " },
  { id: "119", test_id: "37", answer: "Хориглоно " },
  {
    id: "120",
    test_id: "37",
    answer: "Өөдөөс яваа тээврийн хэрэгсэлгүй үед зөвшөөрнө ",
  },

  // Q 3.18
  {
    id: "121",
    test_id: "38",
    answer: "Бүх төрлийн тээврийн хэрэгслийг ",
  },
  {
    id: "122",
    test_id: "38",
    answer:
      "Удаан явдалт тээврийн хэрэгсэл, ердийн хөсөг, унадаг дугуй, мопед, хоёр дугуйт мотоциклоос бусдыг",
  },
  {
    id: "123",
    test_id: "38",
    answer: "Зөвхөн цагт 30 км-ээс илүү хурдтай явааг ",
  },

  // Q 3.19
  { id: "124", test_id: "39", answer: "Хориглоно " },
  {
    id: "125",
    test_id: "39",
    answer: "Өөдөөс яваа тээврийн хэрэгсэлгүй үед зөвшөөрнө ",
  },
  {
    id: "126",
    test_id: "39",
    answer: "Автобусны бүх жин 3.5 тонноос их бол хориглоно ",
  },

  // Q 3.20
  { id: "127", test_id: "40", answer: "Зөвшөөрнө " },
  { id: "128", test_id: "40", answer: "Хориглоно " },
  {
    id: "129",
    test_id: "40",
    answer:
      "Зөвхөн суудлын автомашин цагт 30 км-ээс бага хурдтай яваа тохиолдолд зөвшөөрнө [cite: 272, 273]",
  },
  // Q 3.21
  { id: "130", test_id: "41", answer: "Зөвхөн А" },
  { id: "131", test_id: "41", answer: "Зөвхөн В" },
  { id: "132", test_id: "41", answer: "Зөвхөн А, Б" },
  { id: "133", test_id: "41", answer: "Зөвхөн Б, В" },
  { id: "134", test_id: "41", answer: "А, Б, В" },

  // Q 3.22
  { id: "135", test_id: "42", answer: "Зөвхөн чиглэлийн тээврийн хэрэгсэл" },
  { id: "136", test_id: "42", answer: "Зөвхөн ачааны автомашин" },
  { id: "137", test_id: "42", answer: "Хоёуланг зөвшөөрнө" },
  { id: "138", test_id: "42", answer: "Хоёуланг хориглоно" },

  // Q 3.23
  { id: "139", test_id: "43", answer: "Зөвхөн А" },
  { id: "140", test_id: "43", answer: "Зөвхөн В" },
  { id: "141", test_id: "43", answer: "Зөвхөн А, Б" },

  // Q 3.24
  { id: "142", test_id: "44", answer: "Зөвхөн А" },
  { id: "143", test_id: "44", answer: "Зөвхөн Б" },
  { id: "144", test_id: "44", answer: "А, Б" },

  // Q 3.25
  { id: "145", test_id: "45", answer: "Зөвшөөрнө" },
  { id: "146", test_id: "45", answer: "Хориглоно" },

  // Q 3.26
  {
    id: "147",
    test_id: "46",
    answer:
      "Ачааны автомашин зөвхөн баруун гар тийш эргэх шаардлагатайг мэдээлнэ",
  },
  {
    id: "148",
    test_id: "46",
    answer:
      "Тухайн зам нь зөвхөн ачааны автомашины хөдөлгөөнд зориулагдсан болохыг мэдээлнэ",
  },
  {
    id: "149",
    test_id: "46",
    answer: "Ачааны автомашины хөдөлгөөний тохиромжтой чигийг мэдээлнэ",
  },

  // Q 3.27
  { id: "150", test_id: "47", answer: "Зөвхөн Б" },
  { id: "151", test_id: "47", answer: "Зөвхөн Г" },
  { id: "152", test_id: "47", answer: "Зөвхөн А, Б" },
  { id: "153", test_id: "47", answer: "Зөвхөн А, Б, Г" },
  { id: "154", test_id: "47", answer: "А, Б, В, Г" },

  // Q 3.28
  { id: "155", test_id: "48", answer: "Зөвшөөрнө" },
  { id: "156", test_id: "48", answer: "Хориглоно" },
  {
    id: "157",
    test_id: "48",
    answer:
      "Зөвхөн бүх жин нь 3.5 тонноос их ачааны автомашин жолоодож яваа тохиолдолд хориглоно",
  },

  // Q 3.29
  { id: "158", test_id: "49", answer: "Зөвхөн чигээрээ" },
  { id: "159", test_id: "49", answer: "Чигээрээ буюу баруун гар тийш" },
  { id: "160", test_id: "49", answer: "Чигээрээ буюу буцаж эргэх чигт" },

  // Q 3.30
  { id: "161", test_id: "50", answer: "Зөвхөн А" },
  { id: "162", test_id: "50", answer: "Зөвхөн Б" },
  { id: "163", test_id: "50", answer: "А, Б" },

  // Q 3.31
  {
    id: "164",
    test_id: "51",
    answer: "Зөвхөн механикжсан тээврийн хэрэгсэл чирч яваа",
  },
  { id: "165", test_id: "51", answer: "Зөвхөн чиргүүл чирч яваа" },
  { id: "166", test_id: "51", answer: "Хоёуланг хориглоно" },

  // Q 3.32
  { id: "167", test_id: "52", answer: "Зөвшөөрнө" },
  { id: "168", test_id: "52", answer: "Хориглоно" },
  {
    id: "169",
    test_id: "52",
    answer:
      "Бүх жин нь 3.5 тонноос их автомашин жолоодож яваа тохиолдолд хориглоно",
  },

  // Q 3.33
  { id: "170", test_id: "53", answer: "Зөвшөөрнө" },
  { id: "171", test_id: "53", answer: "Хориглоно" },
  {
    id: "172",
    test_id: "53",
    answer: "Тогтоосон чиглэлийн дагуу нийтийн үйлчилгээнд яваа бол зөвшөөрнө",
  },

  // Q 3.34
  { id: "173", test_id: "54", answer: "Зөвшөөрнө" },
  { id: "174", test_id: "54", answer: "Хориглоно" },
  {
    id: "175",
    test_id: "54",
    answer: "Хүүхдүүдийг зохион байгуулалттай тээвэрлэж яваа бол зөвшөөрнө",
  },

  // Q 3.35
  { id: "176", test_id: "55", answer: "Бүх жин нь 8 тонноос их бол хориглоно" },
  {
    id: "177",
    test_id: "55",
    answer: "Зөвхөн бодит жин нь 8 тонноос их бол хориглоно",
  },
  {
    id: "178",
    test_id: "55",
    answer: "Зөвхөн 8-аас дээш тооны зорчигчтой бол хориглоно",
  },
  { id: "179", test_id: "55", answer: "Автобусны хөдөлгөөнийг хориглохгүй" },

  // Q 3.36
  { id: "180", test_id: "56", answer: "Зөвхөн А" },
  { id: "181", test_id: "56", answer: "Зөвхөн Б" },
  { id: "182", test_id: "56", answer: "А, Б" },

  // Q 3.37
  { id: "183", test_id: "57", answer: "Зөвхөн А" },
  { id: "184", test_id: "57", answer: "Зөвхөн Б" },
  { id: "185", test_id: "57", answer: "Хоёул хориглоно" },
  { id: "186", test_id: "57", answer: "Хоёул зөвшөөрнө" },

  // Q 3.38
  { id: "187", test_id: "58", answer: "Зөвхөн А" },
  { id: "188", test_id: "58", answer: "Зөвхөн Б" },
  { id: "189", test_id: "58", answer: "Хоёул хориглоно" },
  { id: "190", test_id: "58", answer: "Хоёул зөвшөөрнө" },

  // Q 3.39
  { id: "191", test_id: "59", answer: "Зөвхөн А" },
  { id: "192", test_id: "59", answer: "Зөвхөн Б" },
  { id: "193", test_id: "59", answer: "А, Б" },

  // Q 3.40
  { id: "194", test_id: "60", answer: "Зөвхөн А" },
  { id: "195", test_id: "60", answer: "Зөвхөн Б" },
  { id: "196", test_id: "60", answer: "А, Б" },
  // Q 4.1
  { id: "197", test_id: "61", answer: "Чиргүүл чирч яваа уед" },
  {
    id: "198",
    test_id: "61",
    answer: "Механикжсан тээврийн хэрэгсэл чирч яваа үед",
  },
  { id: "199", test_id: "61", answer: "Дээрх хоёр тохиолдолд" },

  // Q 4.2
  {
    id: "200",
    test_id: "62",
    answer:
      "Чирүүлэх механикжсан тээврийн хэрэгслийн ослын дохионы гэрэл нь ажиллахгүй тохиолдолд",
  },
  {
    id: "201",
    test_id: "62",
    answer:
      "Чиргүүлийн ослын дохионы гэрэл нь ажиллахгүй буюу байхгүй тохиолдолд",
  },
  {
    id: "202",
    test_id: "62",
    answer: "Хүнд буюу овор ихтэй, мөн аюултай ачаа тээвэрлэх тохиолдолд",
  },
  { id: "203", test_id: "62", answer: "Дээрх бүх тохиолдолд" },

  // Q 4.3
  { id: "204", test_id: "63", answer: "Ослын дохионы гэрлээ асааж явна" },
  { id: "205", test_id: "63", answer: "Ойрын гэрлээ асааж явна" },
  { id: "206", test_id: "63", answer: "Оврын гэрлээ асааж явна" },
  { id: "207", test_id: "63", answer: "Гэрэл асаах шаардлагагүй" },

  // Q 4.4
  {
    id: "208",
    test_id: "64",
    answer:
      "«Хуухэд тээвэрлэж яваа тээврийн хэрэгсэл» таних тэмдэг бүхий автобус",
  },
  { id: "209", test_id: "64", answer: "Чиглэлийн тээврийн хэрэгсэл" },
  {
    id: "210",
    test_id: "64",
    answer: "Хот хоорондын болон аялал, жуулчлалын автобус",
  },
  { id: "211", test_id: "64", answer: "Дээрх бүгд" },

  // Q 4.5
  { id: "212", test_id: "65", answer: "Шаардлагатай" },
  {
    id: "213",
    test_id: "65",
    answer: "Хориглоогүй газарт зогссон бол шаардлагагүй",
  },
  {
    id: "214",
    test_id: "65",
    answer:
      "Ойрын гэрлээ асааж хөдөлгөөнд оролцож байгаа тохиолдолд шаардлагагүй",
  },

  // Q 4.6
  { id: "215", test_id: "66", answer: "Оврын гэрлээ асаана" },
  { id: "216", test_id: "66", answer: "Дуут дохио өгнө" },
  {
    id: "217",
    test_id: "66",
    answer: "Ослын зогсолтын тэмдэг тавьж анхааруулна",
  },

  // Q 4.7
  { id: "218", test_id: "67", answer: "Зөвхөн дуут дохио" },
  { id: "219", test_id: "67", answer: "Зөвхөн гэрэл шилжүүлэх дохио" },
  { id: "220", test_id: "67", answer: "Дээрх хоёуланг зөвшөөрнө" },
  {
    id: "221",
    test_id: "67",
    answer: "Анхааруулах дохио хэрэглэхийг хориглоно",
  },

  // Q 4.8
  { id: "222", test_id: "68", answer: "Уулзвар дээр зогссон тохиолдолд" },
  { id: "223", test_id: "68", answer: "Гүүрэн дээр зогссон тохиолдолд" },
  {
    id: "224",
    test_id: "68",
    answer: "Төмөр замын гарам дээр зогссон тохиолдолд",
  },
  { id: "225", test_id: "68", answer: "Дээрх бүх тохиолдолд" },

  // Q 4.9
  { id: "226", test_id: "69", answer: "Зөвхөн хүнд ачаа тээвэрлэж яваа үед" },
  {
    id: "227",
    test_id: "69",
    answer: "Зөвхөн овор ихтэй ачаа тээвэрлэж яваа үед",
  },
  {
    id: "228",
    test_id: "69",
    answer: "Зөвхөн аюултай ачаа тээвэрлэж яваа үед",
  },
  { id: "229", test_id: "69", answer: "Дээрх бүх тохиолдолд" },

  // Q 4.10
  { id: "230", test_id: "70", answer: "Шаардлагатай" },
  { id: "231", test_id: "70", answer: "Шаардлагагүй" },
  {
    id: "232",
    test_id: "70",
    answer: "Зөвхөн хүнд буюу овор ихтэй ачаа тээвэрлэж яваа бол шаардлагатай",
  },

  // Q 4.11
  { id: "233", test_id: "71", answer: "Ойрын гэрлээ асаана" },
  { id: "234", test_id: "71", answer: "Ослын дохионы гэрлээ асаана" },
  {
    id: "235",
    test_id: "71",
    answer: "Бүхээг дээрээ улбар шар өнгийн гурван гэрэл асаана",
  },
  {
    id: "236",
    test_id: "71",
    answer: "Чиргүүлийн ард ослын зогсолтын тэмдэг байрлуулна",
  },

  // Q 4.12
  { id: "237", test_id: "72", answer: "Өдрийн цагаар хөдөлгөөнд оролцохдоо" },
  { id: "238", test_id: "72", answer: "Харанхуй үед зөвхөн явж байхдаа" },
  {
    id: "239",
    test_id: "72",
    answer: "Харанхуй үед явж байхдаа болон зогсож байхдаа",
  },
  { id: "240", test_id: "72", answer: "Дээрх бүх тохиолдолд" },

  // Q 4.13
  { id: "241", test_id: "73", answer: "Зөвхөн чиргүүлтэй трактор" },
  {
    id: "242",
    test_id: "73",
    answer: "Чиргүүлтей трактор болон угсраа автобус",
  },
  {
    id: "243",
    test_id: "73",
    answer: "Зөвхөн механикжсан тээврийн хэрэгсэл чирч яваа ачааны автомашин",
  },

  // Q 4.14
  { id: "244", test_id: "74", answer: "Шаардлагатай" },
  { id: "245", test_id: "74", answer: "Шаардлагагүй" },
  {
    id: "246",
    test_id: "74",
    answer: "Нийт урт нь 20 м-ээс бага бол шаардлагагүй",
  },

  // Q 4.15
  { id: "247", test_id: "76", answer: "Зөвхөн А" },
  { id: "248", test_id: "76", answer: "Зөвхөн Б" },
  { id: "249", test_id: "76", answer: "Зөвхөн В" },
  { id: "250", test_id: "76", answer: "Зөвхөн А, В" },
  { id: "251", test_id: "76", answer: "А, Б, В" },

  // Q 4.16
  { id: "252", test_id: "75", answer: "Зөвхөн А" },
  { id: "253", test_id: "75", answer: "Зөвхөн Б" },
  { id: "254", test_id: "75", answer: "А, Б" },

  // Q 4.17
  { id: "255", test_id: "77", answer: "Овор ихтэй ачаатай тээврийн хэрэгсэлд" },
  { id: "256", test_id: "77", answer: "Аюултай ачаатай тээврийн хэрэгсэлд" },
  { id: "257", test_id: "77", answer: "Хүнд ачаатай тээврийн хэрэгсэлд" },
  { id: "258", test_id: "77", answer: "Урт тээврийн хэрэгсэлд" },

  // Q 4.18
  { id: "259", test_id: "78", answer: "40 км/цаг" },
  { id: "260", test_id: "78", answer: "50 км/цаг" },
  { id: "261", test_id: "78", answer: "60 км/цаг" },
  { id: "262", test_id: "78", answer: "70 км/цаг" },

  // Q 4.19
  { id: "263", test_id: "79", answer: "Аюултай бодисын ангиллын дугаар" },
  {
    id: "264",
    test_id: "79",
    answer: "Аюултай ачааны шинж чанарыг харуулсан дүрсэн тэмдэглэгээ",
  },
  { id: "265", test_id: "79", answer: "Аюулын тэмдэглэгээний код" },
  { id: "266", test_id: "79", answer: "Аюултай ачааны жин" },

  // Q 4.20
  { id: "267", test_id: "80", answer: "Шаардлагатай" },
  { id: "268", test_id: "80", answer: "Шаардлагагүй" },
  {
    id: "269",
    test_id: "80",
    answer: "Сав, баглаа, боодлыг ариутгаагуй бол шаардлагатай",
  },
  { id: "270", test_id: "81", answer: "Хориглоно" },
  {
    id: "271",
    test_id: "81",
    answer:
      "Бусад тээврийн хэрэгслийн хөдөлгөөнд саад учруулахгүй бол зөвшөөрнө",
  },

  // Q 5.2
  {
    id: "272",
    test_id: "82",
    answer:
      "Өөдөөсөө болон зэрэгцээ эгнээнд араасаа яваа тээврийн хэрэгсэлд зам тавьж өгсний дараа эргэхийг зөвшөөрнө",
  },
  {
    id: "273",
    test_id: "82",
    answer: "Баруун гар талын эгнээнээс эргэхийг хориглоно",
  },

  // Q 5.3
  {
    id: "274",
    test_id: "83",
    answer:
      "Бусад тээврийн хэрэгсэлд зам тавьж өгсний дараа эргэхийг зөвшөөрнө",
  },
  { id: "275", test_id: "83", answer: "Хориглоно" },

  // Q 5.4
  { id: "276", test_id: "84", answer: "Зөвшөөрнө" },
  {
    id: "277",
    test_id: "84",
    answer: "Баруун гар талын эгнээ чөлөөгүй бол зөвшөөрнө",
  },
  {
    id: "278",
    test_id: "84",
    answer: "Гүйцэх буюу саадыг тойрон гарахаас бусад тохиолдолд хориглоно",
  },

  // Q 5.5
  { id: "279", test_id: "85", answer: "Зөвшөөрнө" },
  {
    id: "280",
    test_id: "85",
    answer: "Баруун гар талын эгнээ чөлөөтэй байгаа тохиолдолд хориглоно",
  },

  // Q 5.6
  { id: "281", test_id: "86", answer: "Зөвшөөрнө" },
  {
    id: "282",
    test_id: "86",
    answer: "Баруун гар талын эгнээ чөлөөтэй тохиолдолд хориглоно",
  },
  {
    id: "283",
    test_id: "86",
    answer:
      "Баруун гар талын нэг ба хоёр дахь эгнээнээс бусад эгнээгээр байрлан явахыг хориглоно",
  },

  // Q 5.7
  { id: "284", test_id: "87", answer: "Зөвшөөрнө" },
  { id: "285", test_id: "87", answer: "Хориглоно" },
  {
    id: "286",
    test_id: "87",
    answer:
      "Зөвхөн бүх жин 3.5 тонноос их ачааны автомашин жолоодож яваа тохиолдолд хориглоно",
  },

  // Q 5.8
  { id: "287", test_id: "88", answer: "Зөвшөөрнө" },
  { id: "288", test_id: "88", answer: "Хориглоно" },
  {
    id: "289",
    test_id: "88",
    answer: "Ачааны автомашины бүх жин 3.5 тонноос их бол хориглоно",
  },

  // Q 5.9
  { id: "290", test_id: "89", answer: "Зөвшөөрнө" },
  { id: "291", test_id: "89", answer: "Хориглоно" },
  { id: "292", test_id: "89", answer: "Зөвхөн тууш замд хориглоно" },

  // Q 5.10
  { id: "293", test_id: "90", answer: "Зөвхөн чигээрээ" },
  { id: "294", test_id: "90", answer: "Зөвхөн зүүн гар тийш" },
  {
    id: "295",
    test_id: "90",
    answer: "Зөвхөн зүүн гар тийш буюу буцаж эргэх чигт",
  },
  { id: "296", test_id: "90", answer: "Дээрх бүх чигт" },

  // Q 5.11
  { id: "297", test_id: "91", answer: "Зөвшөөрнө" },
  { id: "298", test_id: "91", answer: "Хориглоно" },
  {
    id: "299",
    test_id: "91",
    answer: "Автобусны бүх жин 3.5 тонноос их бол хориглоно",
  },

  // Q 5.12
  { id: "300", test_id: "92", answer: "Хориглоно" },
  {
    id: "301",
    test_id: "92",
    answer: "Автобусны бүх жин 3.5 тонноос их бол хориглоно",
  },
  {
    id: "302",
    test_id: "92",
    answer: "Хөдөлгөөний эрчим ихтэй, бусад эгнээ чөлөөгүй үед зөвшөөрнө",
  },

  // Q 5.13
  { id: "303", test_id: "93", answer: "Зөвшөөрнө" },
  {
    id: "304",
    test_id: "93",
    answer:
      "Чиглэлийн тээврийн хэрэгслийн эгнээнд хөдөлгөөний ачаалал ихэссэн үед зөвшөөрнө",
  },
  {
    id: "305",
    test_id: "93",
    answer: "Зөвхөн гүйцэх үйлдэл хийх тохиолдолд зөвшөөрнө",
  },
  { id: "306", test_id: "93", answer: "Хориглоно" },

  // Q 5.14
  { id: "307", test_id: "94", answer: "Зөвшөөрнө" },
  {
    id: "308",
    test_id: "94",
    answer: "Зөвхөн 22 цагаас 06 цагийн хооронд зөвшөөрнө",
  },
  {
    id: "309",
    test_id: "94",
    answer:
      "Зөвхөн «Хүүхэд тээвэрлэж яваа тээврийн хэрэгсэл» таних тэмдэг бүхий автобусыг зөвшөөрнө",
  },
  { id: "310", test_id: "94", answer: "Хориглоно" },

  // Q 5.15
  { id: "311", test_id: "95", answer: "Зөвхөн А" },
  { id: "312", test_id: "95", answer: "Зөвхөн Б" },
  { id: "313", test_id: "95", answer: "А, Б" },

  // Q 5.16
  { id: "314", test_id: "96", answer: "Зөвшөөрнө" },
  { id: "315", test_id: "96", answer: "Хориглоно" },
  {
    id: "316",
    test_id: "96",
    answer:
      "Зөвхөн чиглэлийн тээврийн хэрэгсэл жолоодож яваа тохиолдолд хориглоно",
  },

  // Q 5.17
  {
    id: "317",
    test_id: "97",
    answer: "Баруун гар талын эгнээ чөлөөгүй тохиолдол олд зөвшөөрнө",
  },
  {
    id: "318",
    test_id: "97",
    answer: "Зөвхөн гүйцэх үйлдэл хийх тохиолдолд зөвшөөрнө",
  },
  { id: "319", test_id: "97", answer: "Хориглоно" },

  // Q 5.18
  {
    id: "320",
    test_id: "98",
    answer: "Баруун гар талын эгнээ чөлөөгүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "321",
    test_id: "98",
    answer: "Зөвхөн гүйцэх үйлдэл хийх тохиолдолд зөвшөөрнө",
  },
  { id: "322", test_id: "98", answer: "Хориглоно" },

  // Q 5.19
  { id: "323", test_id: "99", answer: "Зөвшөөрнө" },
  { id: "324", test_id: "99", answer: "Хориглоно" },
  { id: "325", test_id: "99", answer: "Зөвхөн тууш замд хориглоно" },

  // Q 5.20
  {
    id: "326",
    test_id: "100",
    answer: "Баруун гар талын эгнээ чөлөөгүй тохиолдолд зөвшөөрнө",
  },
  {
    id: "327",
    test_id: "100",
    answer: "Зөвхөн гүйцэх үйлдэл хийх тохиолдолд зөвшөөрнө",
  },
  {
    id: "328",
    test_id: "100",
    answer: "Автобусны бүх жин 3.5 тонноос их бол хориглоно",
  },
  { id: "329", test_id: "100", answer: "Хориглоно" },
  // Q 6.1
  { id: "330", test_id: "101", answer: "50 км/цаг" },
  { id: "331", test_id: "101", answer: "60 км/цаг" },
  { id: "332", test_id: "101", answer: "80 км/цаг" },
  {
    id: "333",
    test_id: "101",
    answer: "Бүх жин нь 3.5 тонноос их бол 70 км/цаг",
  },

  // Q 6.2
  { id: "334", test_id: "102", answer: "Зөвхөн суурин газарт" },
  { id: "335", test_id: "102", answer: "Зөвхөн суурин газрын гадна" },
  { id: "336", test_id: "102", answer: "Зөвхөн тууш замд" },
  { id: "337", test_id: "102", answer: "Суурин газрын дотор болон гадна" },
  { id: "338", test_id: "102", answer: "Суурин газрын гадна болон тууш замд" },

  // Q 6.3
  { id: "339", test_id: "103", answer: "60 км/цаг" },
  {
    id: "340",
    test_id: "103",
    answer: "Бүх жин нь 3.5 тонноос их бол 80 км/цаг",
  },
  { id: "341", test_id: "103", answer: "100 км/цаг" },

  // Q 6.4
  { id: "342", test_id: "104", answer: "40 км/цаг" },
  { id: "343", test_id: "104", answer: "60 км/цаг" },
  { id: "344", test_id: "104", answer: "80 км/цаг" },
  { id: "345", test_id: "104", answer: "100 км/цаг" },

  // Q 6.5
  { id: "346", test_id: "105", answer: "40 км/цаг" },
  { id: "347", test_id: "105", answer: "50 км/цаг" },
  { id: "348", test_id: "105", answer: "60 км/цаг" },
  { id: "349", test_id: "105", answer: "70 км/цаг" },

  // Q 6.6
  { id: "350", test_id: "106", answer: "50 км/цаг" },
  { id: "351", test_id: "106", answer: "60 км/цаг" },
  { id: "352", test_id: "106", answer: "70 км/цаг" },
  { id: "353", test_id: "106", answer: "80 км/цаг" },

  // Q 6.7
  { id: "354", test_id: "107", answer: "Зөвхөн суурин газарт" },
  { id: "355", test_id: "107", answer: "Зөвхөн суурин газрын гадна" },
  { id: "356", test_id: "107", answer: "Зөвхөн тууш замд" },
  { id: "357", test_id: "107", answer: "Суурин газрын гадна болон тууш замд" },

  // Q 6.8
  { id: "358", test_id: "108", answer: "Зөвшөөрнө" },
  { id: "359", test_id: "108", answer: "Хориглоно" },
  {
    id: "360",
    test_id: "108",
    answer: "Хүн тээвэрлээгүй тохиолдолд зөвшөөрнө",
  },

  // Q 6.9
  { id: "361", test_id: "109", answer: "Зөвхөн хүн тээвэрлэх үед" },
  {
    id: "362",
    test_id: "109",
    answer: "Зөвхөн хүүхдийг зохион байгуулалттай тээвэрлэх үед",
  },
  { id: "363", test_id: "109", answer: "Дээрх хоёр тохиолдолд" },

  // Q 6.10
  { id: "364", test_id: "110", answer: "Суурин газарт 40 км/цаг" },
  { id: "365", test_id: "110", answer: "Суурин газрын гадна 70 км/цаг" },
  { id: "366", test_id: "110", answer: "Тууш замд 80 км/цаг" },
  { id: "367", test_id: "110", answer: "Дээрх бүх замд 50 км/цаг" },

  // Q 7.1
  { id: "368", test_id: "111", answer: "Зөвшөөрнө" },
  {
    id: "369",
    test_id: "111",
    answer:
      "Нэг чигт 3 буюу түүнээс олон эгнээгээр зорчдог замын хамгийн зүүн гар талын эгнээнд орохыг хориглоно",
  },
  { id: "370", test_id: "111", answer: "Зөвхөн түр зогсохыг зөвшөөрнө" },

  // Q 7.2
  { id: "371", test_id: "112", answer: "Хориглоно" },
  {
    id: "372",
    test_id: "112",
    answer: "Хашлаганд шахаж зогссон бол зөвшөөрнө",
  },
  {
    id: "373",
    test_id: "112",
    answer: "Бүх жин нь 3.5 тонноос их бол хориглоно",
  },

  // Q 7.3
  { id: "374", test_id: "113", answer: "Зөвшөөрнө" },
  { id: "375", test_id: "113", answer: "Хориглоно" },
  {
    id: "376",
    test_id: "113",
    answer: "Зөвхөн бүх жин нь 3.5 тонноос их бол хориглоно",
  },

  // Q 7.4
  {
    id: "377",
    test_id: "114",
    answer:
      "Ачааны автомашины бүх жин нь 3.5 тонноос их бол зөвхөн автобусыг зөвшөөрнө",
  },
  {
    id: "378",
    test_id: "114",
    answer:
      "Ачааны автомашины бүх жин нь 3.5 тонноос бага бол зөвхөн автобусыг хориглоно",
  },
  { id: "379", test_id: "114", answer: "Хоёуланг зөвшөөрнө" },
  { id: "380", test_id: "114", answer: "Хоёуланг хориглоно" },

  // Q 7.5
  {
    id: "381",
    test_id: "115",
    answer: "Урдаа зай үлдээж, талбайн эхлэл хэсэгт (А)",
  },
  {
    id: "382",
    test_id: "115",
    answer: "Урд, хойноо зай үлдээж, талбайг голлож (Б)",
  },
  {
    id: "383",
    test_id: "115",
    answer: "Ардаа зай үлдээж, талбайн төгсгөлд ойртож (В)",
  },

  // Q 7.6
  { id: "384", test_id: "116", answer: "0.5 м-ээс багагуй" },
  { id: "385", test_id: "116", answer: "1 м-ээс багагүй" },
  { id: "386", test_id: "116", answer: "0.5 м-ээс илүүгүй" },
  { id: "387", test_id: "116", answer: "1 м-ээс илүүгүй" },
  {
    id: "388",
    test_id: "116",
    answer: "0.5 м-ээс багагүй бөгөөд 1 м-ээс илүүгүй",
  },

  // Q 7.7
  { id: "389", test_id: "117", answer: "Зөвхөн түр зогсоохыг зөвшөөрнө" },
  {
    id: "390",
    test_id: "117",
    answer: "Хөдөлгүүрийг унтраасан бол удаан зогсоохыг зөвшөөрнө",
  },
  { id: "391", test_id: "117", answer: "Хориглоно" },

  // Q 7.8
  {
    id: "392",
    test_id: "118",
    answer: "Автомашины хөдөлгүүрийг унтраасан бол зөвшөөрнө",
  },
  {
    id: "393",
    test_id: "118",
    answer: "Автомашины бүх жин нь 3.5 тонноос их бол хориглоно",
  },
  {
    id: "394",
    test_id: "118",
    answer:
      "Нэмэлт тэмдгээр тусгайлан заасан зогсоолын талбайгүй хэсэгт хориглоно",
  },

  // Q 7.9
  { id: "395", test_id: "119", answer: "Зөвшөөрнө" },
  {
    id: "396",
    test_id: "119",
    answer:
      "Хороолол дотор бүх жин нь 3.5 тонноос их ачааны автомашиныг удаан зогсоохыг хориглоно",
  },

  // Q 7.10
  { id: "397", test_id: "120", answer: "Хориглоно" },
  { id: "398", test_id: "120", answer: "Хөдөлгүүрийг унтраасан бол зөвшөөрнө" },
  {
    id: "399",
    test_id: "120",
    answer: "Бүх жин нь 3.5 тонноос их бол хориглоно",
  },
  // Q 8.1
  {
    id: "400",
    test_id: "121",
    answer: "Төмөр замын гарам хуртэл 10 м-ээс багагүй зайд",
  },
  {
    id: "401",
    test_id: "121",
    answer: "Төмөр зам хүртэл 10 м-ээс багагүй зайд",
  },
  { id: "402", test_id: "121", answer: "«Төмөр замын гарам» тэмдгийн өмнө" },

  // Q 8.2
  { id: "403", test_id: "122", answer: "Зөвхөн тээвэрлэх байдлаар гаргана" },
  {
    id: "404",
    test_id: "122",
    answer: "Цагт 8 км-ээс бага хурдаар аажим явуулж гаргана",
  },
  { id: "405", test_id: "122", answer: "Зөвхөн хатуу холбоогоор чирч гаргана" },

  // Q 8.3
  { id: "406", test_id: "123", answer: "Шаардлагатай" },
  { id: "407", test_id: "123", answer: "Шаардлагагүй" },
  {
    id: "408",
    test_id: "123",
    answer: "Механизмын явах анги нь гармыг гэмтээхээргүй бол шаардлагагүй",
  },

  // Q 8.4
  { id: "409", test_id: "124", answer: "2.5 м" },
  { id: "410", test_id: "124", answer: "3 м" },
  { id: "411", test_id: "124", answer: "4 м" },
  { id: "412", test_id: "124", answer: "4.5 м" },

  // Q 8.5
  { id: "413", test_id: "125", answer: "Шаардлагатай" },
  { id: "414", test_id: "125", answer: "Шаардлагагүй" },
  {
    id: "415",
    test_id: "125",
    answer:
      "Эрх бүхий байгууллагаас баталсан тусгай журам, стандартыг баримталж хөдөлгөөнд оролцож байгаа тохиолдолд шаардлагагүй",
  },

  // Q 8.6
  { id: "416", test_id: "126", answer: "Шаардлагатай" },
  { id: "417", test_id: "126", answer: "Шаардлагагүй" },
  {
    id: "418",
    test_id: "126",
    answer:
      "Ачааны илүү гарсан хэсэгт «Овор ихтэй ачаа» таних тэмдэг байрлуулсан бол шаардлагагүй",
  },

  // Q 8.7
  { id: "419", test_id: "127", answer: "Шаардлагатай" },
  {
    id: "420",
    test_id: "127",
    answer: "Нийт урт нь 20 м-ээс илүүүуй бол шаардлагагүй",
  },

  // Q 8.8
  { id: "421", test_id: "128", answer: "Шаардлагатай" },
  { id: "422", test_id: "128", answer: "Шаардлагагүй" },
  {
    id: "423",
    test_id: "128",
    answer:
      "Тээврийн хэрэгслийн ачаатай овор нь дүрэмд заасан хэмжээнээс хэтрээгүй бол шаардлагагүй",
  },

  // Q 8.9
  { id: "424", test_id: "129", answer: "Шаардлагатай" },
  { id: "425", test_id: "129", answer: "Шаардлагагүй" },

  // Q 8.10
  { id: "426", test_id: "130", answer: "Нэн даруй" },
  {
    id: "427",
    test_id: "130",
    answer: "Гармыг чөлөөлөх арга хэмжээ үр дүнгүй болсон",
  },

  // Q 9.1
  {
    id: "428",
    test_id: "131",
    answer:
      "Завал 'D' ангиллын тээврийн хэрэгсэл жолоодох эрхтэй байх шаардлагатай",
  },
  {
    id: "429",
    test_id: "131",
    answer:
      "Аль нэг ангиллын тээврийн хэрэгсэл жолоодох эрхтэй байхад хангалттай",
  },
  { id: "430", test_id: "131", answer: "Жолоодох эрхтэй байх шаардлагагүй" },

  // Q 9.2
  {
    id: "431",
    test_id: "132",
    answer: "Зөвхөн зөөлөн холбоогоор чирэх тохиолдолд",
  },
  {
    id: "432",
    test_id: "132",
    answer: "Зөвхөн хатуу холбоогоор чирэх тохиолдолд",
  },
  { id: "433", test_id: "132", answer: "Дээрх хоёр тохиолдолд" },

  // Q 9.3
  { id: "434", test_id: "133", answer: "20 км/цаг" },
  { id: "435", test_id: "133", answer: "30 км/цаг" },
  { id: "436", test_id: "133", answer: "40 км/цаг" },
  { id: "437", test_id: "133", answer: "50 км/цаг" },

  // Q 9.4
  { id: "438", test_id: "134", answer: "Зөвшөөрнө" },
  {
    id: "439",
    test_id: "134",
    answer: "Зөвхөн хатуу холбоогоор чирэх тохиолдолд зөвшөөрнө",
  },
  {
    id: "440",
    test_id: "134",
    answer: "Зөвхен цоройлгон ачих байдлаар чирэх тохиолдолд хориглоно",
  },
  { id: "441", test_id: "134", answer: "Хориглоно" },

  // Q 9.5
  { id: "442", test_id: "135", answer: "Зөвшөөрнө" },
  { id: "443", test_id: "135", answer: "Хориглоно" },
  { id: "444", test_id: "135", answer: "Зөвхөн жолоочийн бүхээгт зөвшөөрнө" },

  // Q 9.6
  {
    id: "445",
    test_id: "136",
    answer: "Зөвхен чирч яваа автобусанд зөвшөөрнө",
  },
  {
    id: "446",
    test_id: "136",
    answer: "Зөвхөн чирүүлж яваа автобусанд зөвшөөрнө",
  },
  { id: "447", test_id: "136", answer: "Хоёуланд нь зөвшөөрнө" },
  { id: "448", test_id: "136", answer: "Хоёуланд нь хориглоно" },

  // Q 9.7
  { id: "449", test_id: "137", answer: "Зөвшөөрнө" },
  { id: "450", test_id: "137", answer: "Хориглоно" },
  {
    id: "451",
    test_id: "137",
    answer: "Нийт урт нь 20 м-ээс илүүгүй бол зөвшөөрнө",
  },

  // Q 9.8
  { id: "452", test_id: "138", answer: "Хориглоно" },
  {
    id: "453",
    test_id: "138",
    answer:
      "Чирч яваа автомашины бодит жин нь чирүүлж яваа тээврийн хэрэгслүүдийн нийлбэр жингээс илүү бол зөвшөөрнө",
  },

  // Q 9.9
  {
    id: "454",
    test_id: "139",
    answer: "Зөвхөн хатуу холбоогоор чирэхийг зөвшөөрнө",
  },
  {
    id: "455",
    test_id: "139",
    answer: "Зөвхөн цоройлгон ачих байдлаар чирэхийг зөвшөөрнө",
  },
  {
    id: "456",
    test_id: "139",
    answer: "Зөвхөн дээрх хоёр аргаар чирэхийг зөвшөөрнө",
  },
  { id: "457", test_id: "139", answer: "Хориглоно" },

  // Q 9.10
  { id: "458", test_id: "140", answer: "Хориглоно" },
  {
    id: "459",
    test_id: "140",
    answer:
      "Чирч яваа автомашины зүтгэх хүч, ажлын тоормосны идэвхжил сайн бол зөвшөөрнө",
  },

  // Q 10.1
  { id: "460", test_id: "141", answer: "Зөвшөөрнө" },
  { id: "461", test_id: "141", answer: "Хориглоно" },
  {
    id: "462",
    test_id: "141",
    answer:
      "Зөвхөн ачааг дагалдан буюу хулээж авахаар явах хүмүүсийг тэвшний хашлаганы дээд ирмэгээс нам зассан суудалд суулгаж тээвэрлэхийг зөвшөөрнө",
  },

  // Q 10.2
  { id: "463", test_id: "142", answer: "Хориглоно" },
  {
    id: "464",
    test_id: "142",
    answer:
      "Тэвшний хашлаганы дээд ирмэгээс нам дор суулгаж тээвэрлэхийг зөвшөөрнө",
  },

  // Q 10.3
  { id: "465", test_id: "143", answer: "Зөвшөөрнө" },
  { id: "466", test_id: "143", answer: "Хориглоно" },
  {
    id: "467",
    test_id: "143",
    answer: "Ачааг унахаас хамгаалан түшиж яваа бол зөвшөөрнө",
  },

  // Q 10.4
  { id: "468", test_id: "144", answer: "Хориглоно" },
  {
    id: "469",
    test_id: "144",
    answer: "Зорчигчид ачааг дагалдаж яваа бол зөвшөөрнө",
  },

  // Q 10.5
  { id: "470", test_id: "145", answer: "Хориглоно" },
  {
    id: "471",
    test_id: "145",
    answer:
      "Тэвшний хашлаганы дээд ирмэгээс нам зассан суудалд суулгаж яваа тохиолдолд зөвшөөрнө",
  },

  // Q 10.6
  { id: "472", test_id: "146", answer: "Зөвшөөрнө" },
  { id: "473", test_id: "146", answer: "Хориглоно" },
  {
    id: "474",
    test_id: "146",
    answer: "Зөвхөн кранны ажил үүрэг гүйцэтгэх хүнийг тээвэрлэхийг зөвшөөрнө",
  },

  // Q 10.7
  { id: "475", test_id: "147", answer: "Зөвшөөрнө" },
  {
    id: "476",
    test_id: "147",
    answer: "Зөвхөн хот хооронд зорчигч тээвэрлэх тохиолдолд зөвшөөрнө",
  },
  {
    id: "477",
    test_id: "147",
    answer:
      "Зөвхөн батлан хамгаалах, хууль сахиулах, хил хамгаалах, онцой байдлын байгууллагад зөвшөөрнө",
  },
  { id: "478", test_id: "147", answer: "Хориглоно" },

  // Q 10.8
  { id: "479", test_id: "148", answer: "Зөвшөөрнө" },
  { id: "480", test_id: "148", answer: "Хориглоно" },
  {
    id: "481",
    test_id: "148",
    answer: "Жолоочоос өөр харгалзаж хамгаалах хүн хамт яваа бол зөвшөөрнө",
  },

  // Q 10.9
  {
    id: "482",
    test_id: "149",
    answer:
      "Зөвхөн хүүхдийн нэмэгдэл суудал буюу хамгаалах хэрэгсэл ашигласан тохиолдолд зөвшөөрнө",
  },
  {
    id: "483",
    test_id: "149",
    answer: "Насанд хүрсэн хүн өвөр дээрээ авч явах бол зөвшөөрнө",
  },
  {
    id: "484",
    test_id: "149",
    answer:
      "140 см-ээс өндөр хүүхдийг зорчигчийн хамгаалах бүс зүүлгэн тээвэрлэх тохиолдолд зөвшөөрнө",
  },
  { id: "485", test_id: "149", answer: "Дээрх бүх тохиолдолд зөвшөөрнө" },
  { id: "486", test_id: "149", answer: "Хориглоно" },

  // Q 10.10
  { id: "487", test_id: "150", answer: "Зөвшөөрнө" },
  { id: "488", test_id: "150", answer: "Хориглоно" },
  { id: "489", test_id: "150", answer: "Зөвхөн суурин газарт зөвшөөрнө" },

  // Q 10.11
  { id: "490", test_id: "151", answer: "Шаардлагатай" },
  { id: "491", test_id: "151", answer: "Шаардлагагүй" },
  {
    id: "492",
    test_id: "151",
    answer: "Зөвхөн 140 см-ээс өндөр хүүхдийн хувьд шаардлагагүй",
  },

  // Q 10.12
  { id: "493", test_id: "152", answer: "Зөвшөөрнө" },
  { id: "494", test_id: "152", answer: "Хориглоно" },

  // Q 10.13
  { id: "495", test_id: "153", answer: "Гүйцэд зогсоогүй байхдаа хаалга нээх" },
  { id: "496", test_id: "153", answer: "Зоригчийг зогсоогоор нь тээвэрлэх" },
  {
    id: "497",
    test_id: "153",
    answer: "Суудлын тооноос илүү зорчигч тээвэрлэх",
  },
  { id: "498", test_id: "153", answer: "Зорчигчийн өвөр дээр хүн тээвэрлэх" },
  { id: "499", test_id: "153", answer: "Дээрх бүгдийг хориглоно" },

  // Q 10.14
  { id: "500", test_id: "154", answer: "Зөвшөөрнө" },
  { id: "501", test_id: "154", answer: "Хориглоно" },
  {
    id: "502",
    test_id: "154",
    answer:
      "Зөвхөн суурин газрын доторх чиглэлийн тээврийн хэрэгслийн жолоочид зөвшөөрнө",
  },

  // Q 10.15
  { id: "503", test_id: "155", answer: "Зөвшөөрнө" },
  { id: "504", test_id: "155", answer: "Хориглоно" },
  {
    id: "505",
    test_id: "155",
    answer: "Зорчигч зориулалтын бариулаас барьж яваа тохиолдолд зөвшөөрнө",
  },

  // Q 10.16
  {
    id: "506",
    test_id: "156",
    answer: "Жолоочийн хөдөлмөр, амралтын горимыг зөрчих",
  },
  { id: "507", test_id: "156", answer: "Зорчигчийг зогсоогоор нь тээвэрлэх" },
  {
    id: "508",
    test_id: "156",
    answer: "Суудлын тооноос олон зорчигч тээвэрлэх",
  },
  {
    id: "509",
    test_id: "156",
    answer: "Зорчигчийн суудлыг хамгаалах бүсээр тоноглоогүй байх",
  },
  { id: "510", test_id: "156", answer: "Дээрх бүгдийг хориглоно" },

  // Q 10.17
  { id: "511", test_id: "157", answer: "Шаардлагатай" },
  { id: "512", test_id: "157", answer: "Шаардлагагүй" },
  {
    id: "513",
    test_id: "157",
    answer: "Хотын доторх аялалд явах бол шаардлагагүй",
  },

  // Q 10.18
  {
    id: "514",
    test_id: "158",
    answer: "Хүүхдийг зохион байгуулалттай тээвэрлэх автобус",
  },
  {
    id: "515",
    test_id: "158",
    answer: "Хот хооронд зорчигч тээвэрлэх автобус",
  },
  { id: "516", test_id: "158", answer: "Хотын доторх чиглэлийн автобус" },
  { id: "517", test_id: "158", answer: "Аялал, жуулчлалаар явах автобус" },
  { id: "518", test_id: "158", answer: "Дээрх бүх автобусанд шаардана" },

  // Q 10.19
  { id: "519", test_id: "159", answer: "Зөвшөөрнө" },
  { id: "520", test_id: "159", answer: "Хориглоно" },
  {
    id: "521",
    test_id: "159",
    answer: "Зөвхөн хот хооронд аяллаар явах тохиолдолд хориглоно",
  },

  // Q 10.20
  { id: "522", test_id: "160", answer: "Зөвшөөрнө" },
  { id: "523", test_id: "160", answer: "Хориглоно" },
  {
    id: "524",
    test_id: "160",
    answer:
      "Зөвхөн хотын доторх чиглэлийн аютобусаар тээвэрлэх тохиолдолд зөвшөөрнө",
  },
  // Q 11.1
  {
    id: "525",
    test_id: "161",
    answer:
      "Ачааны жинг автомашины техникийн тодорхойлолтоор тогтоосон даацаас хэтрүүлэхгүй байх",
  },
  {
    id: "526",
    test_id: "161",
    answer: "Ачааг автомашины овроос илүү гаргахгүй байх",
  },
  {
    id: "527",
    test_id: "161",
    answer:
      "Харанхуй үед болон үзэгдэлт хангалтгүй нөхцөлд ачаа аль болох тод өнгийн, боломжтой бол гэрэл ойлгох шинж чанар бүхий бүтээлгээр хучсан байх",
  },
  { id: "528", test_id: "161", answer: "Дээрх бүх нөхцөлийг хангах" },

  // Q 11.2
  {
    id: "529",
    test_id: "162",
    answer: "Гадна талын гэрэл, гэрэл ойлгуурыг халхлаагуй байх",
  },
  {
    id: "530",
    test_id: "162",
    answer: "Чиг заах гэрэл, гараар өгөх дохиог халхлахгуй байх",
  },
  {
    id: "531",
    test_id: "162",
    answer: "Улсын дугаар, таних тэмдгийг халхлаагүй байх",
  },
  { id: "532", test_id: "162", answer: "Дээрх бүх нөхцөлийг хангасан байх" },

  // Q 11.3
  { id: "533", test_id: "163", answer: "Хориглоно" },
  {
    id: "534",
    test_id: "163",
    answer: "Зам ба орчныг их хэмжээгээр бохирдуулахааргүй байвал зөвшөөрнө",
  },
  {
    id: "535",
    test_id: "163",
    answer:
      "Зөвхөн ойр байгаа зогсоол буюу засварын газарт очих хүртэл хөдөлгөөнө үргэлжлүүлэхийг зөвшөөрнө",
  },

  // Q 11.4
  { id: "536", test_id: "164", answer: "Жолооны механизм ажиллахгүй болсон" },
  {
    id: "537",
    test_id: "164",
    answer: "Ачааны байрлал өөрчлөгдөж, автомашины тогтворжилт алдагдсан",
  },
  {
    id: "538",
    test_id: "164",
    answer: "Тэвшний түгжээ эвдэрч, ачаа унаж болзошгүй болсон",
  },
  { id: "539", test_id: "164", answer: "Дээрх бүх тохиолдолд" },

  // Q 11.5
  { id: "540", test_id: "165", answer: "Зөвшөөрнө" },
  { id: "541", test_id: "165", answer: "Хориглоно" },
  {
    id: "542",
    test_id: "165",
    answer: "Зөвхөн суурин газарт 22 цагаас 06 цагийн хооронд хориглоно",
  },

  // Q 11.6
  { id: "543", test_id: "166", answer: "Зөвшөөрнө" },
  { id: "544", test_id: "166", answer: "Хориглоно" },
  {
    id: "545",
    test_id: "166",
    answer: "Зөвхөн 22 цагаас 06 цагийн хооронд хориглоно",
  },

  // Q 11.7
  { id: "546", test_id: "167", answer: "Зөвшөөрнө" },
  { id: "547", test_id: "167", answer: "Хориглоно" },
  {
    id: "548",
    test_id: "167",
    answer: "Дуу чимээ гаргаж ачих, буулгахыг хориглоно",
  },

  // Q 11.8
  { id: "549", test_id: "168", answer: "2.5 метр" },
  { id: "550", test_id: "168", answer: "3 метр" },
  { id: "551", test_id: "168", answer: "4 метр" },
  { id: "552", test_id: "168", answer: "5 метр" },

  // Q 11.9
  {
    id: "553",
    test_id: "169",
    answer:
      "Ачааны илүү гарсан хэсэгт «Овор ихтэй ачаа» таних тэмдэг байрлуулна",
  },
  { id: "554", test_id: "169", answer: "Тусгай журам, стандарт баримтална" },
  { id: "555", test_id: "169", answer: "Дээрх хоёр арга хэмжээг авна" },

  // Q 11.10
  {
    id: "556",
    test_id: "170",
    answer:
      "Ачааны илүү гарсан хэсэгт «Овор ихтэй ачаа» таних тэмдэг байрлуулна",
  },
  { id: "557", test_id: "170", answer: "Тусгай журам, стандарт баримтална" },
  { id: "558", test_id: "170", answer: "Дээрх хоёр арга хэмжээг авна" },

  // Q 11.11
  { id: "559", test_id: "171", answer: "Шаардлагатай" },
  {
    id: "560",
    test_id: "171",
    answer: "Нийт урт нь 20 м-ээс илүүгүй бол шаардлагагүй",
  },

  // Q 11.12
  { id: "561", test_id: "172", answer: "Шаардлагатай" },
  { id: "562", test_id: "172", answer: "Шаардлагагүй" },
  {
    id: "563",
    test_id: "172",
    answer: "Зөвхөн хоёр чиргүүлтэй бол шаардлагатай",
  },

  // Q 11.13
  { id: "564", test_id: "173", answer: "Шаардлагатай" },
  { id: "565", test_id: "173", answer: "Шаардлагагүй" },
  {
    id: "566",
    test_id: "173",
    answer:
      "Тээврийн хэрэгслийн ард «Урт тээврийн хэрэгсэл» таних тэмдэг байрлуулсан бол шаардлагагүй",
  },

  // Q 11.14
  {
    id: "567",
    test_id: "174",
    answer:
      "Сүүлийн чиргүүлийн ард «Урт тээврийн хэрэгсэл» таних тэмэг байрлуулсан бол зөвшөөрнө",
  },
  {
    id: "568",
    test_id: "174",
    answer: "Тусгай журам, стандарт баримтлах бол зөвшөөнө",
  },
  {
    id: "569",
    test_id: "174",
    answer: "Дээрх хоёр арга хэмжээг авсан тохиолдолд зөвшөөрнө",
  },
  { id: "570", test_id: "174", answer: "Хориглоно" },

  // Q 11.15
  { id: "571", test_id: "175", answer: "Зөвшөөрнө" },
  {
    id: "572",
    test_id: "175",
    answer: "Нийт урт нь 20 м-ээс илүүгүй бол зөвшөөрнө",
  },
  {
    id: "573",
    test_id: "175",
    answer: "Тусгай журам, стандарт баримтлах бол зөвшөөрнө",
  },
  { id: "574", test_id: "175", answer: "Хориглоно" },

  // Q 11.16
  {
    id: "575",
    test_id: "176",
    answer: "«Овор ихтэй ачаа» таних тэмдэг байрлуулна",
  },
  { id: "576", test_id: "176", answer: "Тусгай журам, стандарт баримтална" },
  { id: "577", test_id: "176", answer: "Дээрх хоёр арга хэмжээг авна" },
  {
    id: "578",
    test_id: "176",
    answer: "Дээрх хоёр арга хэмжээг авах шаардлагагүй",
  },

  // Q 11.17
  { id: "579", test_id: "177", answer: "Шаардлагатай" },
  {
    id: "580",
    test_id: "177",
    answer: "Нийт урт нь 20 м-ээс илүүгүй бол шаардлагагүй",
  },

  // Q 11.18
  {
    id: "581",
    test_id: "178",
    answer: "бүхээг дээрээ улбар шар енгийн гурван гэрэл асаана",
  },
  { id: "582", test_id: "178", answer: "Ойрын гэрлээ асааж явна" },
  {
    id: "583",
    test_id: "178",
    answer:
      "Ачааны илүү гарсан хэсгийн урд нь цагаан, ард нь улаан өнгийн гэрэл буюу гэрэл ойлгуур байрлуулна",
  },

  // Q 11.19
  {
    id: "584",
    test_id: "179",
    answer:
      "Тээврийн хэрэгслийнхээ урд болон ард «Аюултай ачаа» таних тэмдэг байрлуулна",
  },
  {
    id: "585",
    test_id: "179",
    answer:
      "Эрх бүхий байгууллагаас баталсан тусгай журам, стандартыг баримтална",
  },
  { id: "586", test_id: "179", answer: "Өдрийн цагт ойрын гэрлээ асааж явна" },
  { id: "587", test_id: "179", answer: "Дээрх бүх арга хэмжээг авна" },

  // Q 11.20
  { id: "588", test_id: "180", answer: "Хүнд ачаатай тээврийн хэрэгсэл" },
  { id: "589", test_id: "180", answer: "Аюултай ачаатай тээврийн хэрэгсэл" },
  { id: "590", test_id: "180", answer: "Удаан явдалт тээврийн хэрэгсэл" },
  { id: "591", test_id: "180", answer: "Дээрх бүгд" },

  // Q 12.1
  { id: "592", test_id: "181", answer: "Зөвшөөрнө" },
  { id: "593", test_id: "181", answer: "Хориглоно" },
  {
    id: "594",
    test_id: "181",
    answer:
      "Аюулгуй байдлыг хангаж аль ойр байгаа зогсоол буюу засварын газарт очих хүртэл хөдөлгөөнөө үргэлжлүүлэхийг зөвшөөрнө",
  },

  // Q 12.2
  { id: "595", test_id: "182", answer: "Зөвшөөрнө" },
  {
    id: "596",
    test_id: "182",
    answer: "Чирэгчийн тоормосны ажиллагаа сайн бол зөвшөөрнө",
  },
  { id: "597", test_id: "182", answer: "Хориглоно" },

  // Q 12.3
  { id: "598", test_id: "183", answer: "Гүйдэл хэмжүүр ажиллахгүй болсон" },
  {
    id: "599",
    test_id: "183",
    answer:
      "Хөдөлгүүрийн хөргөлтийн шингэний температур хэмжүүр ажиллахгүй болсон",
  },
  {
    id: "600",
    test_id: "183",
    answer:
      "Хийн дамжуулгатай тоормосны системийн даралт хэмжүүр ажиллахгүй болсон",
  },
  { id: "601", test_id: "183", answer: "Дээрх бүх тохиолдолд" },

  // Q 12.4
  { id: "602", test_id: "184", answer: "Суудлын автомашин" },
  { id: "603", test_id: "184", answer: "Бүх төрлийн ачааны автомашин" },
  {
    id: "604",
    test_id: "184",
    answer: "Зөвхөн бүх жин нь 3.5 тонноос их ачааны автомашин",
  },
  { id: "605", test_id: "184", answer: "Автобус болон троллейбус" },

  // Q 12.5
  { id: "606", test_id: "185", answer: "Суудлын автомашин" },
  { id: "607", test_id: "185", answer: "Бүх төрлийн ачааны автомашин" },
  {
    id: "608",
    test_id: "185",
    answer: "Зөвхөн бүх жин нь 3.5 тонноос их ачааны автомашин",
  },
  { id: "609", test_id: "185", answer: "Автобус болон троллейбус" },

  // Q 12.6
  {
    id: "610",
    test_id: "186",
    answer:
      "Хурдны хайрцгийн араан дамжуулга хүндрэлтэй залгагддаг, өөрөө салдаг болсон",
  },
  { id: "611", test_id: "186", answer: "Кардан голд цав үүссэн" },
  { id: "612", test_id: "186", answer: "Тослох материал гоожсон" },
  { id: "613", test_id: "186", answer: "Дээрх бүх тохиолдолд хориглоно" },

  // Q 12.7
  {
    id: "614",
    test_id: "187",
    answer: "Гадна талын гэрлийн бүрхүүл бохирдсон",
  },
  { id: "615", test_id: "187", answer: "Улсын дугаар бүдгэрсэн" },
  { id: "616", test_id: "187", answer: "Хөдөлгүүрийн очлуур бохирдсон" },
  { id: "617", test_id: "187", answer: "Тэвшний өнгө үзэмж илт муудсан" },
  { id: "618", test_id: "187", answer: "Дээрх бүх тохиолдолд зөвшөөрнө" },

  // Q 12.8
  {
    id: "619",
    test_id: "188",
    answer: "Хаалгаа харах тольгүй буюу толио буруу байрлуулсан",
  },
  {
    id: "620",
    test_id: "188",
    answer: "Ослын нэмэгдэл хаалгыг нээх боломжгүй болсон",
  },
  { id: "621", test_id: "188", answer: "Хаалга гүйцэд хаагдахгүй болсон" },
  { id: "622", test_id: "188", answer: "Дээрх бүх тохиолдолд хориглоно" },

  // Q 12.9
  { id: "623", test_id: "189", answer: "Шаардлагатай" },
  {
    id: "624",
    test_id: "189",
    answer: "Зөвхөн бүх жин нь 3.5 тонноос их бол шаардлагатай",
  },
  {
    id: "625",
    test_id: "189",
    answer: "Ослын дохионы гэрлүүд бүрэн ажиллагаатай бол шаардлагагүй",
  },

  // Q 12.10
  { id: "626", test_id: "190", answer: "Шаардлагатай" },
  {
    id: "627",
    test_id: "190",
    answer: "Автобусны бүх жин 5 тонноос их бол шаардлагатай",
  },
  {
    id: "628",
    test_id: "190",
    answer: "Зогсоолын тоормос бүрэн ажиллагаатай бол шаардлагагүй",
  },

  // Q 13.1
  { id: "629", test_id: "191", answer: "8 метр орчим" },
  { id: "630", test_id: "191", answer: "16 метр орчим" },
  { id: "631", test_id: "191", answer: "26 метр орчим" },
  { id: "632", test_id: "191", answer: "30 метр орчим" },

  // Q 13.2
  {
    id: "633",
    test_id: "192",
    answer: "Анхаарал муудаж, самбаачлах хугацаа багасна",
  },
  {
    id: "634",
    test_id: "192",
    answer: "Анхаарал сайжирч, самбаачлах хугацаа ихэснэ",
  },
  {
    id: "635",
    test_id: "192",
    answer: "Анхаарал муудаж, самбаачлах хугацаа ихэснэ",
  },

  // Q 13.3
  { id: "636", test_id: "193", answer: "Жолоочийн самбаачлах чадвараас" },
  {
    id: "637",
    test_id: "193",
    answer: "Тоормосны системийн ажиллах хугацаанаас",
  },
  { id: "638", test_id: "193", answer: "Зам, дугуйн барьцалдах чанараас" },
  { id: "639", test_id: "193", answer: "Дээрх бүгдээс" },

  // Q 13.4
  { id: "640", test_id: "194", answer: "Дугуйн хээний элэгдлээс" },
  { id: "641", test_id: "194", answer: "Дугуй дээрх ачааллаас" },
  { id: "642", test_id: "194", answer: "Зорчих хэсгийн гадаргуугийн байдлаас" },
  { id: "643", test_id: "194", answer: "Дээрх бүгдээс" },

  // Q 13.5
  { id: "644", test_id: "195", answer: "Автомашин ачаатай үед" },
  { id: "645", test_id: "195", answer: "Автомашин ачаагүй үед" },
  {
    id: "646",
    test_id: "195",
    answer: "Автомашин ачаатай эсэх нь зам, дугуйн барьцалтад нөлөөлөхгүй",
  },

  // Q 13.6
  { id: "647", test_id: "196", answer: "Хүндийн төв нь доор байрласан" },
  { id: "648", test_id: "196", answer: "Хүндийн төв нь дээр байрласан" },
  { id: "649", test_id: "196", answer: "Хүндийн төв нь хажуу тал руу шилжсэн" },

  // Q 13.7
  { id: "650", test_id: "197", answer: "Хурд ихтэй явах үед" },
  { id: "651", test_id: "197", answer: "Тоормослох үед" },
  { id: "652", test_id: "197", answer: "Ачаа ачих үед" },
  { id: "653", test_id: "197", answer: "Дээрх бүх тохиолдолд" },

  // Q 13.8
  {
    id: "654",
    test_id: "198",
    answer:
      "Эргэх үед төвөөс зугтах хүчний үйлчлэлээр хүндийн төв хажуу тийш шилждэг учраас",
  },
  { id: "655", test_id: "198", answer: "Хүндийн төв дээшилсэн байдаг учраас" },

  // Q 13.9
  { id: "656", test_id: "199", answer: "Эргэлтийн радиус нэмэгдэх үед" },
  { id: "657", test_id: "199", answer: "Эргэлтийн радиус багасах үед" },
  { id: "658", test_id: "199", answer: "Хөдөлгөөний хурд багасах үед" },

  // Q 13.10
  {
    id: "659",
    test_id: "200",
    answer: "Чиргүүл нь автомашинаас бага тойргоор эргэнэ",
  },
  {
    id: "660",
    test_id: "200",
    answer: "Чиргүүл нь автомашинаас их тойргоор эргэнэ",
  },
  {
    id: "661",
    test_id: "200",
    answer: "Чиргүүл нь автомашинтай ижил тойргоор эргэнэ",
  },
];

export default answers;
